export default {"src":"/_next/static/media/powerUpSolid_24.c9d0d9a9.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};